var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 2.88h-2.666v-1.6c0-.706-.598-1.28-1.334-1.28H4.667C3.93 0 3.333.574 3.333 1.28v1.6H.667A.653.653 0 000 3.52v.64c0 .088.075.16.167.16h1.258l.515 10.46c.033.682.62 1.22 1.33 1.22h9.46c.712 0 1.297-.536 1.33-1.22l.515-10.46h1.258A.164.164 0 0016 4.16v-.64a.653.653 0 00-.667-.64zm-4.166 0H4.833V1.44h6.334v1.44z",
    fill: "#FF5656"
  })));
}

export default SvgTrashRed;